<template>
  <div>
    <happy-hour-bar />
    <router-view />
  </div>
</template>

<script>
import HappyHourBar from "@/components/happy-hour/happy-hour-bar";

export default {
  name: "App",

  components: {
    HappyHourBar
  },

  created() {
    this.$store.dispatch("fetchSettings");
  }
};
</script>

<style></style>
